export default function HeroSection() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center"
      style={{
        backgroundImage:
          'url(https://public.readdy.ai/ai/img_res/ad6f59831d56233b129e92529a172459.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a1e2e]/85 via-[#0a1e2e]/65 to-transparent" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 py-32">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-6">
            <span className="w-8 h-px bg-amber-400" />
            <span className="text-amber-400 text-sm font-medium tracking-widest uppercase">
              Rechtsanwalt in Rostock
            </span>
          </div>

          <h1 className="text-white font-bold leading-tight mb-3">
            <span className="block text-5xl lg:text-7xl tracking-tight">Dr. Dan Oliver</span>
            <span className="block text-5xl lg:text-7xl tracking-tight text-amber-400">Höftmann</span>
          </h1>

          <p className="text-white/70 text-lg font-light tracking-widest uppercase mb-8">
            Rechtsanwalt · Sportrecht &amp; Medizinrecht
          </p>

          <p className="text-white/80 text-lg leading-relaxed mb-10 max-w-lg">
            Kompetente und engagierte Rechtsberatung in Rostock – spezialisiert auf Sportrecht und Medizinrecht.
            Mitglied der DAV-Arbeitsgemeinschaften für Sportrecht und Medizinrecht.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => scrollTo('kontakt')}
              className="px-8 py-4 bg-amber-400 text-[#1A3A52] font-bold rounded-full text-sm tracking-wide hover:bg-amber-300 transition-all cursor-pointer whitespace-nowrap"
            >
              Jetzt Kontakt aufnehmen
            </button>
            <button
              onClick={() => scrollTo('rechtsgebiete')}
              className="px-8 py-4 bg-white/10 border border-white/40 text-white font-medium rounded-full text-sm tracking-wide hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
            >
              Rechtsgebiete entdecken
            </button>
          </div>
        </div>

        {/* Info Card – exakte Daten aus anwaltauskunft.de */}
        <div className="absolute bottom-12 right-8 hidden lg:flex flex-col items-end gap-2">
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-6 py-6 text-right min-w-[260px]">
            <p className="text-white font-bold text-base">Dr. Dan Oliver Höftmann</p>
            <p className="text-amber-400 text-xs font-semibold uppercase tracking-widest mb-3">Rechtsanwalt</p>

            <div className="flex flex-col gap-1 mb-3">
              <p className="text-white/80 text-sm">Kröpeliner Str. 54</p>
              <p className="text-white/80 text-sm">18055 Rostock</p>
            </div>

            <div className="border-t border-white/20 pt-3 mb-3">
              <a
                href="tel:+491772506951"
                className="text-amber-400 font-semibold text-sm hover:text-amber-300 transition-colors"
              >
                +49 (177) 250 69 51
              </a>
            </div>

            <div className="border-t border-white/20 pt-3 flex flex-col gap-1">
              <p className="text-white/50 text-xs uppercase tracking-widest mb-1">DAV-Arbeitsgemeinschaft</p>
              <div className="flex gap-2 justify-end flex-wrap">
                <span className="bg-white/15 text-white text-xs px-2.5 py-1 rounded-full">Sportrecht</span>
                <span className="bg-white/15 text-white text-xs px-2.5 py-1 rounded-full">Medizinrecht</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Mehr erfahren</span>
        <i className="ri-arrow-down-line text-white/50 text-xl" />
      </div>
    </section>
  );
}
